import { colors } from 'ui/theme/colors';

export enum LogoVariants {
  HORIZONTAL = 'horizontal',
  STACKED = 'stacked',
  DIAMOND = 'diamond',
  DIAMOND_BORDERED = 'diamond-bordered',
}

export enum LogoColors {
  BLACK = 'black',
  COLOR = 'color',
  WHITE = 'white',
}

/** The Array of Colors and Opacities for the Logo Fill
 * format - [ [ color, opacity ]x4 ]
 * Defaults to colored logo */
export const LOGO_COLOR_VALUES: {
  [x: string]: [string, number][];
} = {
  [LogoColors.COLOR]: [
    [colors.purple100, 0.15],
    [colors.cyan50, 0.25],
    [colors.green50, 0.25],
    [colors.red50, 0.15],
  ],
  [LogoColors.BLACK]: [
    [colors.grey80, 0.15],
    [colors.grey80, 0.25],
    [colors.grey80, 0.25],
    [colors.grey80, 0.15],
  ],
  [LogoColors.WHITE]: [
    [colors.white, 0.3],
    [colors.white, 0.3],
    [colors.white, 0.3],
    [colors.white, 0.3],
  ],
};

export const TEXT_COLOR_VALUES = {
  [LogoColors.COLOR]: colors.black,
  [LogoColors.BLACK]: colors.grey80,
  [LogoColors.WHITE]: colors.white,
};
